export class FooterRow {
    header: any
    value: any
    isSelected: boolean
    constructor() {
        this.header = ''
        this.value = ''
        this.isSelected = true
    }
}